import { createAction } from '@reduxjs/toolkit';
import { CHNode } from '../../../general/node';

export const newShareButtonClicked = createAction<
  void,
  'creativeHub/sharing/NEW_SHARE_BUTTON_CLICKED'
>('creativeHub/sharing/NEW_SHARE_BUTTON_CLICKED');

export const sidebarEnabled = createAction<void, 'creativeHub/sharing/SIDEBAR_ENABLED'>(
  'creativeHub/sharing/SIDEBAR_ENABLED',
);

export const sidebarExpanded = createAction<void, 'creativeHub/sharing/SIDEBAR_EXPANDED'>(
  'creativeHub/sharing/SIDEBAR_EXPANDED',
);

export const cancelButtonClicked = createAction<void, 'creativeHub/sharing/CANCEL_BUTTON_CLICKED'>(
  'creativeHub/sharing/CANCEL_BUTTON_CLICKED',
);

export const sidebarContracted = createAction<void, 'creativeHub/sharing/SIDEBAR_CONTRACTED'>(
  'creativeHub/sharing/SIDEBAR_CONTRACTED',
);

export const sidebarDisabled = createAction<void, 'creativeHub/sharing/SIDEBAR_DISABLED'>(
  'creativeHub/sharing/SIDEBAR_DISABLED',
);

export const sidebarHidden = createAction<void, 'creativeHub/sharing/SIDEBAR_HIDDEN'>(
  'creativeHub/sharing/SIDEBAR_HIDDEN',
);

export const slipClicked = createAction<void, 'creativeHub/sharing/SLIP_CLICKED'>(
  'creativeHub/sharing/SLIP_CLICKED',
);

export const shareSelectorChanged = createAction<
  { node: CHNode; isChecked: boolean; shift: boolean },
  'creativeHub/sharing/SHARE_SELECTOR_CHANGED'
>('creativeHub/sharing/SHARE_SELECTOR_CHANGED');
export const firstNodeIDSelectedChanged = createAction<
  { nodeID: number },
  'creativeHub/fileManager/firstNodeIDSelectedChanged'
>('creativeHub/fileManager/firstNodeIDSelectedChanged');
export const lastNodeIDSelectedChanged = createAction<
  { nodeID: number },
  'creativeHub/sharing/lastNodeIDSelectedChanged'
>('creativeHub/sharing/lastNodeIDSelectedChanged');
export const selectedNodesChanged = createAction<
  { isSelected: boolean; nodes: CHNode[]; replace: boolean },
  'creativeHub/sharing/selectedNodesChanged'
>('creativeHub/sharing/selectedNodesChanged');

export const shareSelectorAllChecked = createAction<
  { nodes: CHNode[] },
  'creativeHub/sharing/SHARE_SELECTOR_ALL_CHECKED'
>('creativeHub/sharing/SHARE_SELECTOR_ALL_CHECKED');

export const shareSelectorAllUnchecked = createAction<
  { nodes: CHNode[] },
  'creativeHub/sharing/SHARE_SELECTOR_ALL_UNCHECKED'
>('creativeHub/sharing/SHARE_SELECTOR_ALL_UNCHECKED');

export const expiresInChanged = createAction<
  { value: string },
  'creativeHub/sharing/EXPIRES_IN_CHANGED'
>('creativeHub/sharing/EXPIRES_IN_CHANGED');

export const nameChangedUiEvent = createAction<
  { value: string },
  'creativeHub/sharing/NAME_CHANGED_UI_EVENT'
>('creativeHub/sharing/NAME_CHANGED_UI_EVENT');

export const radioChangedUiEvent = createAction<
  { value: boolean },
  'creativeHub/sharing/RADIO_CHANGED_UI_EVENT'
>('creativeHub/sharing/RADIO_CHANGED_UI_EVENT');

export const shareNameChanged = createAction<
  { value: string },
  'creativeHub/sharing/SHARE_NAME_CHANGED'
>('creativeHub/sharing/SHARE_NAME_CHANGED');

export const genShareLinkButtonClicked = createAction<
  void,
  'creativeHub/sharing/GEN_SHARE_LINK_BUTTON_CLICKED'
>('creativeHub/sharing/GEN_SHARE_LINK_BUTTON_CLICKED');

export const createShareStarted = createAction<void, 'creativeHub/sharing/CREATE_SHARE_STARTED'>(
  'creativeHub/sharing/CREATE_SHARE_STARTED',
);

export const createShareSuccess = createAction<any, 'creativeHub/sharing/CREATE_SHARE_SUCCESS'>(
  'creativeHub/sharing/CREATE_SHARE_SUCCESS',
);

export const createShareError = createAction<any, 'creativeHub/sharing/CREATE_SHARE_ERROR'>(
  'creativeHub/sharing/CREATE_SHARE_ERROR',
);

export const clipboardButtonClicked = createAction<
  void,
  'creativeHub/sharing/CLIPBOARD_BUTTON_CLICKED'
>('creativeHub/sharing/CLIPBOARD_BUTTON_CLICKED');
